import { getDocument } from "./Sanity";

export const addNewDay = (data, decimalValue) => {
  const result = JSON.parse(JSON.stringify(data));
  // console.log("first result ", result);
  // Extract the Time Series object
  const timeSeries = result["Time Series (Daily)"];

  // Get all the dates (keys) and sort them in descending order (newest first)
  const dates = Object.keys(timeSeries).sort(
    (a, b) => new Date(b) - new Date(a)
  );

  // Find the latest date and determine the next day
  const latestDate = new Date(dates[0]);
  const nextDate = new Date(latestDate);
  nextDate.setDate(latestDate.getDate() + 1);

  // Format the next date as YYYY-MM-DD
  const nextDateString = nextDate.toISOString().split("T")[0];

  // Create a new entry for the next date with the given decimal value
  const newEntry = {
    "1. open": decimalValue.toFixed(4), // Ensures 4 decimal places
    "2. high": (decimalValue * 1.02).toFixed(4), // Example: high is 2% more
    "3. low": (decimalValue * 0.98).toFixed(4), // Example: low is 2% less
    "4. close": decimalValue.toFixed(4), // Same as the open value
    "5. volume": Math.floor(Math.random() * 500000000), // Random volume
  };

  // Add the new date and its corresponding values to the time series
  timeSeries[nextDateString] = newEntry;

  // Return the modified JSON object as a string
  return JSON.stringify(result, null, 4);
};
export const removeUntilKeyFound = (data, keyToSearch) => {
  // Clone the original data to avoid mutating the input
  const result = { ...data };
  // console.log("first result ", result);
  // Extract the Time Series object
  const timeSeries = result["Time Series (Daily)"];

  //let daysToReturn = result["Time Series (Daily)"];
  // Get all the dates (keys) and sort them in descending order (newest first)
  let dates = Object.keys(timeSeries).sort((a, b) => new Date(b) - new Date(a));
  try {
    Object.keys(timeSeries).forEach((_item) => {
      if (keyToSearch == _item) {
        throw {};
      }
      dates = dates.slice(1);
    });
  } catch (error) {}
  // console.log("dates ", dates);

  // Remove the last `daysToRemove` dates
  //const datesToKeep = dates.slice(1);
  // console.log("datesToKeep ", datesToKeep);

  // Rebuild the Time Series object with only the remaining dates
  const newTimeSeries = {};
  dates.forEach((date) => {
    newTimeSeries[date] = timeSeries[date];
  });

  // console.log("newTimeSeries ", newTimeSeries);
  // Update the result object with the new Time Series
  result["Time Series (Daily)"] = newTimeSeries;
  result["Meta Data"]["3. Last Refreshed"] = keyToSearch;

  // Return the modified JSON object as a string

  // console.log("final object result ", result);
  // console.log("returning ", JSON.stringify(result));
  return result;
};
export const removeLastXDays = (data, daysToRemove) => {
  // Clone the original data to avoid mutating the input
  const result = JSON.parse(JSON.stringify(data));
  // console.log("first result ", result);
  // Extract the Time Series object
  const timeSeries = result["Time Series (Daily)"];

  // Get all the dates (keys) and sort them in descending order (newest first)
  const dates = Object.keys(timeSeries).sort(
    (a, b) => new Date(b) - new Date(a)
  );
  // console.log("dates ", dates);

  // Remove the last `daysToRemove` dates
  const datesToKeep = dates.slice(daysToRemove);
  // console.log("datesToKeep ", datesToKeep);

  // Rebuild the Time Series object with only the remaining dates
  const newTimeSeries = {};
  datesToKeep.forEach((date) => {
    newTimeSeries[date] = timeSeries[date];
  });

  // console.log("newTimeSeries ", newTimeSeries);
  // Update the result object with the new Time Series
  result["Time Series (Daily)"] = newTimeSeries;

  // Return the modified JSON object as a string

  // console.log("final object result ", result);
  // console.log("returning ", JSON.stringify(result));
  return JSON.stringify(result);
};
export const reduceToLastXDays = (data, days) => {
  // Clone the original data to avoid mutating the input
  const result = JSON.parse(JSON.stringify(data));
  // console.log("first result ", result);
  // Extract the Time Series object
  const timeSeries = result["Time Series (Daily)"];

  // Get all the dates (keys) and sort them in descending order (newest first)
  const dates = Object.keys(timeSeries).sort(
    (a, b) => new Date(a) - new Date(b)
  );
  //
  // console.log("dates ", dates);

  // Remove the last `daysToRemove` dates
  const datesToKeep = dates.slice(dates.length - days);
  // console.log("datesToKeep ", datesToKeep);

  // Rebuild the Time Series object with only the remaining dates
  const newTimeSeries = {};
  datesToKeep.forEach((date) => {
    newTimeSeries[date] = timeSeries[date];
  });

  // console.log("newTimeSeries ", newTimeSeries);
  // Update the result object with the new Time Series
  result["Time Series (Daily)"] = newTimeSeries;

  // Return the modified JSON object as a string

  // console.log("final object result ", result);
  // console.log("returning ", JSON.stringify(result));
  return JSON.stringify(result);
};
export const verifyNumberInsidePercentageRange = (
  _range,
  _baseNum,
  _numToVerify
) => {
  const topMargin = (1 + _range / 100) * _baseNum;
  const botMargin = (1 - _range / 100) * _baseNum;
  const toReturn = (_num) => _num >= botMargin && _num <= topMargin;

  //console.log("verifying ", botMargin, topMargin, _numToVerify, toReturn(_numToVerify));
  return toReturn(_numToVerify);
  // if ((_numToVerify) => botMargin && _numToVerify <= topMargin) {
  //   return true;
  // } else {
  //   return false;
  // }
};
export const getOrganizedPriceArray = (dataArray) => {
  let parsedDataArray = [];
  let loopCount = 0;
  try {
    Object.keys(dataArray).forEach((key) => {
      const date = new Date(key);
      const price = parseFloat(dataArray[key]["4. close"]);
      const newRecord = {
        date: date,
        price: price,
      };
      parsedDataArray = parsedDataArray.concat(newRecord);
      //stop the loop when the max number of days is reached
      // if (loopCount >= days) {
      //   throw {};
      // }
    });
  } catch (error) {}
  // console.log("first date before sort ", parsedDataArray[0].date);
  parsedDataArray.sort((a, b) => a.date.getTime() - b.date.getTime());
  return parsedDataArray;
};
// ----- PREDICTION FUNCTIONS
//this function gets the average price giving the number of interval days
//take inspiration from this function to build a similar one that given an array of days, returns an array of averages of those days
export const getPrediction = (parsedDataArray, days) => {
  const startAvg2 = Math.floor(days * 0.1);
  const endAvg2 = Math.floor(days * 0.05);
  //const today = new Date(formatDate(new Date()));
  const lastDate = parsedDataArray[parsedDataArray.length - 1].date;
  const lastPrice = parsedDataArray[parsedDataArray.length - 1].price;
  //const startPeriodDate = addDaysToDate(today, 0 - days).getTime();
  const startAvg1Date =
    parsedDataArray[parsedDataArray.length - days].date.getTime();
  const startAvg2Date =
    parsedDataArray[parsedDataArray.length - startAvg2].date.getTime();
  const endAvg2Date =
    parsedDataArray[parsedDataArray.length - endAvg2].date.getTime();

  const totalDays = parsedDataArray.length;
  const firstPrice = parsedDataArray[0].price;
  const startAvg2Price =
    parsedDataArray[parsedDataArray.length - startAvg2].price;
  const endAvg2Price = parsedDataArray[parsedDataArray.length - endAvg2].price;
  // console.log(
  //   "startAvg2Price ",
  //   startAvg2Price,
  //   "endAvg2Price ",
  //   endAvg2Price
  // );
  let sumAvg1 = 0;
  let countAvg1 = 0;
  let sumAvg2 = 0;
  let countAvg2 = 0;
  let aritmeticAvg1 = 0;
  let aritmeticAvg2 = 0;
  //weighted average
  let weightedSumAvg1 = 0;
  let weightedSumAvg2 = 0;
  let sumWeightsAvg1 = 0;
  let sumWeightsAvg2 = 0;
  const weightFactor = 10000;
  //iterative average
  let iterativeAvg1 = startAvg2Price;
  let iterativeAvg2 = endAvg2Price;
  //
  let toReturn = 0;

  //now make the array start from the most recent date
  //parsedDataArray.sort((a, b) => b.date.getTime() - a.date.getTime());
  // console.log("start average loop");
  parsedDataArray.forEach((_obj, index) => {
    // console.log("_obj.date", _obj.date);
    const date = _obj.date.getTime();
    const price = _obj.price;
    try {
      const weight = Math.pow(weightFactor, index / totalDays); // Exponential weighting (more recent dates get higher weight)
      // console.log("weight ", weight);
      if (startAvg1Date <= date && date < startAvg2Date) {
        sumAvg1 += price;
        countAvg1++;

        iterativeAvg1 = (iterativeAvg1 + price) / 2;

        weightedSumAvg1 += price * weight;
        sumWeightsAvg1 += weight;
      }

      if (startAvg2Date <= date && date <= endAvg2Date) {
        sumAvg2 += price;
        countAvg2++;

        iterativeAvg2 = (iterativeAvg2 + price) / 2;

        weightedSumAvg2 += price * weight;
        sumWeightsAvg2 += weight; // Accumulate weights
      }
    } catch (error) {
      console.log(error);
      return 0;
    }
  });

  aritmeticAvg1 = sumAvg1 / countAvg1;
  aritmeticAvg2 = sumAvg2 / countAvg2;
  const weightedAvg1 = weightedSumAvg1 / sumWeightsAvg1;
  const weightedAvg2 = weightedSumAvg2 / sumWeightsAvg2;

  const avg1ForCalculations = weightedAvg1;
  const avg2ForCalculations = weightedAvg2;

  toReturn = avg2ForCalculations - (avg1ForCalculations - avg2ForCalculations);

  return {
    prediction: Math.round(toReturn * 100) / 100, //round to 2 decs
    lastPrice: lastPrice,
    lastDate,
    avg1ForCalculations: Math.round(avg1ForCalculations * 100) / 100,
    avg2ForCalculations: Math.round(avg2ForCalculations * 100) / 100,
    aritmeticAvg1: Math.round(aritmeticAvg1 * 100) / 100,
    aritmeticAvg2: Math.round(aritmeticAvg2 * 100) / 100,
    iterativeAvg1: Math.round(iterativeAvg1 * 100) / 100,
    iterativeAvg2: Math.round(iterativeAvg2 * 100) / 100,
    weightedAvg1: Math.round(weightedAvg1 * 100) / 100,
    weightedAvg2: Math.round(weightedAvg2 * 100) / 100,
  };
};
export const GetPriceAverages = (
  _daysInterval,
  _priceArray,
  _title,
  _pointsPrefix = ""
) => {
  //_daysInterval = [
  //{name:"2 months before", daysStart:75, daysFinish:26},
  //{name:"last month", daysStart:25, daysFinish:2},
  //{name:"last price", daysStart:1, daysFinish:1}
  //] example (we put the 1 to get the last day)
  //those are the days starting from the last

  let dataToReturn = [];

  //variables for weighted average
  const weightFactor = 10000;
  var weightCount = 1;
  var totalWeight = 0;
  var weightedPriceSum = 0;

  //variables for controlling the days interval
  var currentInterval = _daysInterval[0];

  //how to get the right intervar to start into, if we have only 500 days, but our first interval sdtarts from 1000 in the past
  if (currentInterval.daysStart > _priceArray.length) {
    //here we have an interval problem
    console.log("we are out of first interval");
    //get the right interval
    var correctInterval = _daysInterval.filter(
      (_p) =>
        _p.daysStart >= _priceArray.length &&
        _p.daysFinish <= _priceArray.length
    );
    if (correctInterval.length > 0) {
      currentInterval = correctInterval[0];
    } else {
      console.log("we didnt find a correct interval");
    }
  }

  //this means that i will calculate first the most far averages
  _priceArray.forEach((_obj, _index) => {
    const date = _obj.date.getTime();
    const price = _obj.price;

    //here using the index we should know when we are in whitch result to return
    var currentDayBeforeTheLastPrice = _priceArray.length - _index; //this should get lower over time
    if (
      currentDayBeforeTheLastPrice <= currentInterval.daysStart &&
      currentDayBeforeTheLastPrice >= currentInterval.daysFinish
    ) {
      //here we are building up the average
      const weight = Math.pow(
        weightFactor,
        weightCount /
          (currentInterval.daysStart - currentInterval.daysFinish + 1)
      ); // Exponential weighting (more recent dates get higher weight)
      weightCount++;
      totalWeight += weight;
      weightedPriceSum += price * weight;

      if (currentDayBeforeTheLastPrice == currentInterval.daysFinish) {
        //save the interval average in the result array
        var intervalResult = {
          interval: { ...currentInterval },
          priceObj: { ..._obj, date: _obj.date.toISOString() },
          weightedAvg: (weightedPriceSum / totalWeight).toFixed(2),
        };
        dataToReturn = dataToReturn.concat(intervalResult);
        //reset the average variables
        weightCount = 1;
        weightedPriceSum = 0;
        totalWeight = 0;

        //skip to the next interval
        const currentIntervalIndex = _daysInterval.indexOf(currentInterval);
        if (currentIntervalIndex != _daysInterval.length - 1) {
          currentInterval = _daysInterval[currentIntervalIndex + 1];
        }
      }
    }

    //
  });

  // console.log("my interval result", dataToReturn);
  return { dataToReturn, _title, _pointsPrefix };
};
export const GetHistoricalYield = (
  _pricesArray,
  _selectedFinancialAmount,
  _financialData,
  _title,
  _pointsPrefix
) => {
  var dataToReturn = [];
  // console.log("_financialData", _financialData);
  //foreach price in _pricesArray, create another dataToReturn
  _pricesArray.forEach((_interval) => {
    //calculate yield
    var marketCap = _financialData.sharesOutstanding * _interval.weightedAvg;
    // console.log("market cap", marketCap);
    var _yield = (_selectedFinancialAmount / marketCap) * 100;
    // console.log("_yield ", _yield, _selectedFinancialAmount);

    var intervalResult = {
      interval: { ..._interval.interval },
      priceObj: { ..._interval.priceObj },
      weightedAvg: _yield.toFixed(2),
    };
    dataToReturn = dataToReturn.concat(intervalResult);
  });

  return { dataToReturn, _title, _pointsPrefix };
};
//this function only calculated the percentage differences, builds a graph from the averages and builds the text to be written
export const getPredictionResult = (_prediction) => {
  let _details = [];
  const averageDistance =
    _prediction.lastPrice - _prediction.avg1ForCalculations;
  const average2Distance =
    _prediction.lastPrice - _prediction.avg2ForCalculations;
  const difference = _prediction.lastPrice - _prediction.prediction;
  const index =
    Math.round(((100 * difference) / _prediction.prediction) * 100) / 100;
  const averageDistancePerc =
    Math.round(((100 * averageDistance) / _prediction.lastPrice) * 100) / 100;
  // avg2 distance WITH and WITHOUT abs (is more useful)
  const average2DistancePercABS = Math.abs(
    Math.round(((100 * average2Distance) / _prediction.lastPrice) * 100) / 100
  );
  const average2DistancePerc =
    Math.round(((100 * average2Distance) / _prediction.lastPrice) * 100) / 100;

  if (average2DistancePercABS < 2) {
    _details = _details.concat(
      "Market is uncertain: the average is aligned with the last price"
    );
  }

  if (
    _prediction.avg1ForCalculations < _prediction.avg2ForCalculations &&
    _prediction.lastPrice < _prediction.avg1ForCalculations
  ) {
    _details = _details.concat("People started selling");
    // setBgColor("orange");
  }

  if (
    _prediction.avg1ForCalculations > _prediction.avg2ForCalculations &&
    _prediction.lastPrice > _prediction.avg1ForCalculations
  ) {
    _details = _details.concat("People started buying");
    // setBgColor("yellow");
  }
  if (
    _prediction.avg1ForCalculations > _prediction.avg2ForCalculations &&
    _prediction.lastPrice < _prediction.avg1ForCalculations
  ) {
    if (index > 0) {
      _details = _details.concat("People today bought more than expected");
      // setBgColor("red");
    } else {
      _details = _details.concat("People today sold more than expected");
      // setBgColor("darkblue");
    }
  }
  if (
    _prediction.avg1ForCalculations < _prediction.avg2ForCalculations &&
    _prediction.lastPrice > _prediction.avg1ForCalculations
  ) {
    if (index > 0) {
      _details = _details.concat("People are buying a LOT, maybe too much");
      // setBgColor("green");
    } else {
      _details = _details.concat(
        "People are not buying anymore, or are buying much less"
      );
    }
  }

  const dataPoints1 = [
    { value: _prediction.avg1ForCalculations },
    { value: _prediction.avg2ForCalculations },
    { value: _prediction.lastPrice },
  ];
  let proportionedPoints = [];
  const max = Math.max(...dataPoints1.map((p) => p.value));
  const min = Math.min(...dataPoints1.map((p) => p.value));
  const diff = max - min;
  // console.log("min max", min, max);
  dataPoints1.forEach((p, i) => {
    let newPointObject = { value: 1 };

    // console.log("p.value", p.value);
    newPointObject = { value: ((p.value - min) * 4) / diff + 1 };
    if (p.value == max) {
      newPointObject = { value: 5 };
    }
    if (p.value == min) {
      newPointObject = { value: 1 };
    }

    proportionedPoints = proportionedPoints.concat(newPointObject);
  });
  // console.log("proportionedPoints", proportionedPoints);

  return {
    graphPoints: {
      data: proportionedPoints,
      maxValue: 5,
      noOfSections: 5,
      height: 50,
      width: 30,
      // adjustToWidth: true,
      spacing: 10,
      initialSpacing: 5,
    },
    prediction: {
      ...{ ..._prediction },
      index,
      averageDistancePerc,
      average2DistancePerc,
      average2DistancePercABS,
    },
    details: _details,
  };
};
export const LoadAverages = async (_symbol, _onSuccess, _pastDate = "") => {
  getDocument({ _type: "symbolData", symbol: _symbol.symbol }, (_res) => {
    var parsedData = JSON.parse(_res[0].dataJson);
    var _financialData = JSON.parse(_res[0].financialData);
    // console.log("parsed data ", parsedData);
    if (_pastDate != "") {
      parsedData = removeUntilKeyFound(parsedData ?? {}, _pastDate);
      // console.log("parsed data after date", parsedData);
    }

    var dataArray = parsedData["Time Series (Daily)"];
    const lastRefresh = parsedData["Meta Data"]["3. Last Refreshed"];

    var parsedDataArray = getOrganizedPriceArray(dataArray);
    // console.log("first price ", parsedDataArray[0]);
    // console.log("last price ", parsedDataArray[parsedDataArray.length - 1]);

    //what type of averages sohuld we calculate for a single symbol

    //last 3 months + last 10 days + last price //THIS IS WHAT I USE TO ENTER FOR AN INVESTMENT
    var investAverage = GetPriceAverages(
      [
        {
          name: "Historical Value",
          daysStart: 75,
          daysFinish: 11,
        },
        { name: "Market Sentiment", daysStart: 10, daysFinish: 2 },
        { name: "Last Price", daysStart: 1, daysFinish: 1 },
      ],
      parsedDataArray,
      "Average Investing",
      "Weighted Average: "
    );
    // console.log("invest average ", investAverage);
    //load volatility, then return it wit hall orther data
    const intrinsicValue =
      investAverage.dataToReturn[investAverage.dataToReturn.length - 3]
        .weightedAvg; //first position
    const closestAverage =
      investAverage.dataToReturn[investAverage.dataToReturn.length - 2]
        .weightedAvg; //pre-last position

    const finalPrice =
      investAverage.dataToReturn[investAverage.dataToReturn.length - 1]
        .weightedAvg; //last position

    const difference = Math.abs(closestAverage - finalPrice);
    var volatility = (difference * 100) / closestAverage;
    volatility = volatility.toFixed(2);

    var performance = finalPrice - closestAverage;
    performance = (performance * 100) / closestAverage;
    performance = performance.toFixed(2);

    var overpricing = finalPrice - intrinsicValue;
    overpricing = (overpricing * 100) / intrinsicValue;
    overpricing = overpricing.toFixed(2);
    // console.log("ovpr for " + _symbol.symbol + " is " + overpricing);

    // console.log("volatility for " + _symbol.symbol + " is " + volatility);

    //last 10 days separated
    var daysAgoArray = [];
    for (let index = 10; index >= 1; index--) {
      daysAgoArray = daysAgoArray.concat({
        name: "%%formattedDate%% - " + index + " days ago",
        daysStart: index,
        daysFinish: index,
      });
    }
    var daysAverage = GetPriceAverages(
      daysAgoArray,
      parsedDataArray,
      "Last 10 Days",
      "Price: "
    );

    //last 10 months separated + last price
    var monthsAgoArray = [];
    const daysInAMonth = 25;
    for (let index = 7; index >= 1; index--) {
      monthsAgoArray = monthsAgoArray.concat({
        name:
          index == 1
            ? "Last " + index + " month"
            : index - 1 + "-" + index + " months ago",
        daysStart: index * daysInAMonth,
        daysFinish: index * daysInAMonth - daysInAMonth + 1,
      });
    }
    var monthsAverage = GetPriceAverages(
      monthsAgoArray,
      parsedDataArray,
      "Last Months Averages",
      "Monthly Average: "
    );

    //last 10 years separated
    // var yearsAgoArray = [];
    // const daysInAYear = daysInAMonth * 12;
    // for (let index = 10; index >= 1; index--) {
    //   yearsAgoArray = yearsAgoArray.concat({
    //     name:
    //       index == 1
    //         ? "Last " + index + " year"
    //         : index - 1 + "-" + index + " years ago",
    //     daysStart: index * daysInAYear,
    //     daysFinish: index * daysInAYear - daysInAYear + 1,
    //   });
    // }
    // var yearsAverage = GetPriceAverages(
    //   yearsAgoArray,
    //   parsedDataArray,
    //   "Last 10 Years Averages",
    //   "Yearly Average: "
    // );

    //OCF yield in the last 10 months
    if (!!_financialData) {
      var ocfDailyGraph = GetHistoricalYield(
        daysAverage.dataToReturn,
        _financialData.operatingCashFlow,
        _financialData,
        "OCF Yield (Daily)",
        "% "
      );
      var ocfMonthlyGraph = GetHistoricalYield(
        monthsAverage.dataToReturn,
        _financialData.operatingCashFlow,
        _financialData,
        "OCF Yield (Monthly)",
        "% "
      );
      // var ocfYearlyGraph = GetHistoricalYield(
      //   yearsAverage.dataToReturn,
      //   _financialData.operatingCashFlow,
      //   _financialData,
      //   "OCF Yield (Yearly)",
      //   "% "
      // );
      var capexMonthlyGraph = GetHistoricalYield(
        monthsAverage.dataToReturn,
        _financialData.capex,
        _financialData,
        "CapEx Yield (Monthly)",
        "% "
      );
      // console.log("ocfMonthlyGraph", ocfMonthlyGraph);
    }

    const lastPriceObj = parsedDataArray[parsedDataArray.length - 1];
    let averages = [];
    var financialGraphs = [];
    averages = averages.concat(investAverage);
    averages = averages.concat(daysAverage);
    averages = averages.concat(monthsAverage);
    //averages = averages.concat(yearsAverage);
    financialGraphs = financialGraphs.concat(ocfMonthlyGraph);
    financialGraphs = financialGraphs.concat(capexMonthlyGraph);
    financialGraphs = financialGraphs.concat(ocfDailyGraph);
    //financialGraphs = financialGraphs.concat(ocfYearlyGraph);
    const pageData = {
      symbol: _symbol.symbol,
      lastPrice: { ...lastPriceObj, date: lastPriceObj.date.toISOString() },
      lastRefresh,
      averages,
      volatility,
      performance,
      overpricing,
      financialData: _financialData,
      financialGraphs,
    };
    // console.log("symbol pageData", pageData);

    var newState = {};
    newState[_symbol.symbol] = pageData;
    _onSuccess(newState);

    // setactiveSymbol(_symbol);
  });
};

// ----- GRAPHS
export const getGraphFromDataPoints = (dataPoints1, graphName) => {
  let proportionedPoints = [];
  const max = Math.max(...dataPoints1.map((p) => p.value));
  const min = Math.min(...dataPoints1.map((p) => p.value));
  const diff = max - min;
  // console.log("min max", min, max);
  dataPoints1.forEach((p, i) => {
    let newPointObject = { value: 1 };

    // console.log("p.value", p.value);
    newPointObject = { value: ((p.value - min) * 4) / diff + 1 };
    if (p.value == max) {
      newPointObject = { value: 5 };
    }
    if (p.value == min) {
      newPointObject = { value: 1 };
    }

    proportionedPoints = proportionedPoints.concat(newPointObject);
    // proportionedPoints = proportionedPoints.concat({
    //   ...newPointObject,
    //   realVal: p,
    // });
  });
  // console.log("proportionedPoints", proportionedPoints);
  const myGraphData = {
    name: graphName,
    originalPoints: dataPoints1,
    data: proportionedPoints,
    maxValue: 5,
    noOfSections: 5,
    height: 50,
    width: dataPoints1.length * 20,
    // adjustToWidth: true,
    spacing: 10,
    initialSpacing: 5,
  };
  return myGraphData;
};
// export const getPatterns = (parsedDataArray) => {
//   try {
//     //get last 5 days pattern
//     const daysToAnalyze = 5;
//     const performanceInterval = 30;
//     const numberOfPattherToMatch = 5;
//     const deltaForVariationPerc = 2;

//     let mainPattern = [];
//     let graphsToReturn = [];
//     const lastDay = parsedDataArray[parsedDataArray.length - 1];
//     const monthAwatDay =
//       parsedDataArray[parsedDataArray.length - performanceInterval];

//     let mainPatternGraphDataPoints = [];

//     //building main pattern
//     for (let index = daysToAnalyze - 1; index >= 0; index--) {
//       const currentDay = parsedDataArray[parsedDataArray.length - 1 - index];
//       //const dayAfter = parsedDataArray[parsedDataArray.length - index];
//       // console.log("currentDay", currentDay, parsedDataArray.length);

//       // here we are considering the variation of each day with last price
//       let _variation = lastDay.price - currentDay.price;
//       //let _variationPerc = (currentDay.price / lastDay.price) * 100 - 100; was this wrong?
//       let _variationPerc = (lastDay.price / currentDay.price) * 100 - 100;

//       // here we consider the variation of each day with the day before
//       // let _variation = dayAfter.price - currentDay.price;
//       // let _variationPerc = (currentDay.price / dayAfter.price) * 100 - 100;

//       //build graph for the first pattern
//       mainPatternGraphDataPoints = mainPatternGraphDataPoints.concat({
//         value: currentDay.price,
//       });

//       mainPattern = mainPattern.concat({
//         daysBefore: index,
//         variation: _variation,
//         variationPerc: _variationPerc,
//       });
//     }

//     //building graph for main patther
//     var mainPatternGraph = {
//       ...getGraphFromDataPoints(
//         mainPatternGraphDataPoints,
//         formatDate(parsedDataArray[parsedDataArray.length - 1].date)
//       ),
//       monthPerf: (lastDay.price * 100) / monthAwatDay.price - 100,
//       nextDayPerf: 0,
//       perfInterval:
//         monthAwatDay.price.toFixed(2) + " - " + lastDay.price.toFixed(2),
//     };

//     let countCyclesToSkip = 0;
//     //iterate to find all periods with the same pattern
//     parsedDataArray.forEach((_obj, _index) => {
//       if (_index < daysToAnalyze || _index >= parsedDataArray.length - 3) {
//         // console.log(_index, "_index is less than ", daysToAnalyze);
//         return;
//       }
//       if (countCyclesToSkip > 0) {
//         countCyclesToSkip--;
//         return;
//       }

//       let countOfPatternMatches = 0;

//       mainPattern.forEach((element) => {
//         //duplicate the pattern calculation above

//         //here we using the last price of the pattern
//         let _variation =
//           _obj.price - parsedDataArray[_index - element.daysBefore].price;
//         const _lastDayOfPattern = _obj;
//         const _currentDayOfPattern =
//           parsedDataArray[_index - element.daysBefore];
//         // let _variationPerc =
//         //   (currentDayOfPattern.price / _obj.price) * 100 - 100;
//         let _variationPerc =
//           (_lastDayOfPattern.price / _currentDayOfPattern.price) * 100 - 100;

//         //here we tried to use the comparison with each day
//         // const currentDay = parsedDataArray[_index - element.daysBefore]; //parsedDataArray[parsedDataArray.length - 1 - index];
//         // const dayAfter = parsedDataArray[_index - element.daysBefore + 1];
//         // // console.log("calculating patterns days ", currentDay, dayAfter);
//         // let _variation = dayAfter.price - currentDay.price;
//         // let _variationPerc = (currentDay.price / dayAfter.price) * 100 - 100;

//         if (
//           // verifyNumberInsidePercentageRange(
//           //   55,
//           //   element.variation,
//           //   myVariation
//           // )
//           element.variationPerc + deltaForVariationPerc > _variationPerc &&
//           element.variationPerc - deltaForVariationPerc < _variationPerc
//         ) {
//           countOfPatternMatches++;
//         }
//       });

//       let performanceStartDay = { price: parsedDataArray[_index].price };
//       if (_index - performanceInterval >= 0) {
//         performanceStartDay = parsedDataArray[_index - performanceInterval];
//       }
//       var myMonthlyPerformance =
//         (parsedDataArray[_index].price * 100) / performanceStartDay.price - 100;

//       //if matching pattern found
//       if (
//         countOfPatternMatches >= numberOfPattherToMatch
//         // && mainPatternGraph.monthPerf - 5 < myMonthlyPerformance &&
//         // mainPatternGraph.monthPerf + 5 > myMonthlyPerformance
//       ) {
//         //skip the next 4 iterations
//         //we want to avoid showing the same period more times (while it's the same pattern)
//         countCyclesToSkip = 4;

//         // when tou find a period, return the pattern
//         let dataPoints1 = [];
//         for (let index = daysToAnalyze - 1; index >= 0; index--) {
//           //const element = array[index];
//           dataPoints1 = dataPoints1.concat({
//             value: parsedDataArray[_index - index].price,
//           });
//         }

//         //concatenating the resultant of the pattern
//         // dataPoints1 = dataPoints1.concat({
//         //   value: parsedDataArray[_index + 1].price,
//         // });
//         var myNextDayPerf =
//           (parsedDataArray[_index + 1].price * 100) /
//             parsedDataArray[_index].price -
//           100;

//         //i think this is used to see if the price turned out to be positive or negative
//         priceDifference =
//           parsedDataArray[_index + 1].price - parsedDataArray[_index].price;

//         //performanceInterval
//         let myGraphData = {
//           ...getGraphFromDataPoints(
//             dataPoints1,
//             formatDate(parsedDataArray[_index].date)
//           ),
//           monthPerf: myMonthlyPerformance,
//           nextDayPerf: myNextDayPerf,
//           perfInterval:
//             performanceStartDay.price.toFixed(2) +
//             " - " +
//             parsedDataArray[_index].price.toFixed(2),
//           priceDifference: priceDifference,
//         };

//         graphsToReturn = graphsToReturn.concat(myGraphData);
//       }
//     });

//     graphsToReturn = graphsToReturn.concat(mainPatternGraph);
//     return graphsToReturn;
//     //props.orderByIndex(0 - graphsToReturn.length);
//   } catch (error) {
//     console.log("error in getPatterns", error);
//   }
//   //return ;
//   //group the similar patterns, and assign a percentage value to the group ( 5/10 pattern are like this, so there is a 50% chance that this pattern will occur)
// };

// ----- MAIN FUNCTIONS
export const GetSymbolParagraphProps = (
  _graphPoints,
  _paragraphName,
  _paragraphDescription
) => {
  return {};
};
